import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import styles from "../page.module.css";
import EmptyQuestions from "../../../components/EmptyQuestions";
import QuestionBlock from "../../../components/QuestionBlock/QuestionBlock";
import useSurvey from "../../surveys/hooks/useSurvey";
import { useEffect } from "react";

const SurveyPageUI = () => {
  const surveyInfo = useSelector((state) => state.surveyInfo);
  const { id, pageId } = useParams();
  const questions = surveyInfo?.surveyPages?.find(
    (page) => page.id === Number(pageId)
  );
  const { createNewQuestion, getSurveyInfo, getQuestionTypes, questionTypes} = useSurvey();

  useEffect(() => {
    getQuestionTypes()
  }, [])

  const getSurveyInfoHandler = async () => {
    await getSurveyInfo(Number(id));
  };

  const onCreateQuestion = async () => {
    const res = await createNewQuestion({
      id_survey: Number(id),
      id_page: Number(pageId),
      comes_from: 0,
    });

    if (res) {
      await getSurveyInfoHandler();
    }
  };

  return (
    <section className={styles["survey-page"]}>
      {questions?.surveyQuestions?.length === 0 && (
        <EmptyQuestions onCreateQuestion={onCreateQuestion} />
      )}
      {questions?.surveyQuestions?.map((question, index) => (
        <QuestionBlock
          key={question.id_question}
          numberPage={index + 1}
          question={question}
          questionTypes={questionTypes}
          questions={questions}
        />
      ))}
    </section>
  );
};

export default SurveyPageUI;
